import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import {
  getColumnKey,
  JoinStringArrayPipe,
  TableBodyNoReferenceCellComponent,
  TableColumn,
} from '@web/shared/ui';
import { WarehouseReceiptCollectionItem } from '../../models/warehouse-receipt-collection-item';
import { WarehouseReceiptCollectionFilter } from '../../models/warehouse-receipt-collection-filter';
import { WarehouseReceiptStatusComponent } from '../warehouse-receipt-status/warehouse-receipt-status.component';

@Component({
  selector: 'app-warehouse-receipt-list-custom-cell-template',
  imports: [
    JoinStringArrayPipe,
    TableBodyNoReferenceCellComponent,
    WarehouseReceiptStatusComponent,
  ],
  templateUrl: './warehouse-receipt-list-custom-cell-template.component.html',
  styleUrl: './warehouse-receipt-list-custom-cell-template.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WarehouseReceiptListCustomCellTemplateComponent {
  /* prettier-ignore */
  public readonly column = input.required<TableColumn<WarehouseReceiptCollectionItem, WarehouseReceiptCollectionFilter>>();
  /* prettier-ignore */
  public readonly model = input.required<WarehouseReceiptCollectionItem>();
  /* prettier-ignore */
  protected readonly getColumnKey = getColumnKey<WarehouseReceiptCollectionItem>;
}
